//import { combineReducers } from 'redux';
import { createReducer, getType } from 'typesafe-actions';

import { notification as action } from '../actions/notification.actions';
import { notificationInit } from '../dtos/notification.dtos';

const notificationReducer = createReducer(notificationInit)
  .handleType(getType(action), (state, action) => action.payload);

export default notificationReducer;